import React from 'react';
import './styles.css';
import { Col, Row } from 'antd';

const ItemImage = ({ src, text, button1, button2, button3 }) => {
  return (
    <Col xs={24} md={12} align="middle">
      <img
        className="itemImage-col_image"
        src={src}
        alt={`img-element-${text}`}
      />
      <h4 className="itemImage-col_title">{text}</h4>
      <Row
        gutter={[16, 8]}
        align="middle"
        justify="center"
        className="itemImage_row-buttons"
      >
        <Col xs={18} lg={14}>
          {button1}
        </Col>
        <Col xs={18} lg={14}>
          {button2}
        </Col>
        <Col xs={18} lg={14}>
          {button3}
        </Col>
        <Col xs={18} lg={14} />
      </Row>
    </Col>
  );
};

export default ItemImage;
